    <h1>Insurance Details of {{lead.lead_name}}  
        <span *ngIf="myrole == '1' || myrole == '5'">({{lead.mobile}})</span>
        <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
    <div class="row"  *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
    <div class="row" *ngIf="dataLoaded">
        <div class="col-sm-8 border-right" [ngClass]="{'readOnly': myrole == '1' && myrole == '5'}">
        <form [formGroup]="insuranceForm" (submit)="updateInsurance()">
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Policy Number *</label>
                        <input type="text" formControlName="policy_number" class="form-control" />
                        <div *ngIf="submitted && f.policy_number.errors" class="invalid-feedback">
                            <div *ngIf="f.policy_number.errors.required">Policy Number is required</div>
                            <div *ngIf="f.policy_number.errors.minlength">Policy Number must be 10 or greater than 10 characters</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Insurance Company *</label>
                        <input type="text" formControlName="insurance_company" class="form-control" />
                        <div *ngIf="submitted && f.insurance_company.errors" class="invalid-feedback">
                            <div *ngIf="f.insurance_company.errors.required">Insurance Company is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Corporate</label>
                        <input type="text" formControlName="corporate" class="form-control" />
                        <div *ngIf="submitted && f.corporate.errors" class="invalid-feedback">
                            <div *ngIf="f.corporate.errors.required">Corporate is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Employee ID</label>
                        <input type="text" formControlName="employee_id" class="form-control" />
                        <div *ngIf="submitted && f.employee_id.errors" class="invalid-feedback">
                            <div *ngIf="f.employee_id.errors.required">Employee ID is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">TPA *</label>
                        <input type="text" formControlName="tpa" class="form-control" />
                        <div *ngIf="submitted && f.tpa.errors" class="invalid-feedback">
                            <div *ngIf="f.tpa.errors.required">TPA is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Sum Insured *</label>
                        <input type="text" formControlName="sum_insured" class="form-control" />
                        <div *ngIf="submitted && f.sum_insured.errors" class="invalid-feedback">
                            <div *ngIf="f.sum_insured.errors.required">Sum Insured is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Balance Sum Insured</label>
                        <input type="text" formControlName="balance_sum_insured" class="form-control" />
                        <div *ngIf="submitted && f.balance_sum_insured.errors" class="invalid-feedback">
                            <div *ngIf="f.balance_sum_insured.errors.required">Balance Sum Insured is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="form-label">Circle *</label>
                            <mat-select placeholder="Circle" formControlName="circle_id" (click)="setSearchValue('circle')" (selectionChange)="getCircleHospitals($event.value)">
                                <input class="mySearchInput"
                                #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="circleSearch">
                                <mat-option [value]="cir.id" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                            <div *ngIf="submitted && f.circle_id.errors" class="invalid-feedback">
                                <div *ngIf="f.circle_id.errors.required">Circle is required</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <label class="form-label">Treatment *</label>
                        <mat-select placeholder="Select Treatment" formControlName="treatment_id" (click)="setSearchValue('treatment')">
                            <input class="mySearchInput"
                            #treatmentSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'treatment')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="treatmentSearch">
                            <mat-option value="">Select Treatment</mat-option>
                            <mat-option [value]="treatment.id" *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.treatment_id.errors" class="invalid-feedback">
                            <div *ngIf="f.treatment_id.errors.required">Treatment is required</div>
                        </div>
                        <div *ngIf="f.treatment_id.value=='37' && invalidTreatment" class="invalid-feedback">
                            <div>Please select valid treatment</div>
                        </div>
                    </div>

                </div>
            </div>
            <hr>

            <!-------For Preauth Details--------------->
            <span *ngIf="preauth_hospital_name || preauth_arrival_time || preauth_doctor_id">
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6" *ngIf="preauth_hospital_name">
                        <label class="form-label">Hospital (From Preauth)</label>
                        {{preauth_hospital_name}}
                    </div>
                    <div class="col-sm-6" *ngIf="preauth_arrival_time">
                        <label class="form-label">Arrival Date & Time (From Preauth)</label>
                        {{preauth_arrival_time}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6" *ngIf="preauth_doctor_id">
                        <label class="form-label">Doctor (From Preauth)</label>
                        {{preauth_doctor_id}}
                    </div>
                </div>
            </div>
            <hr>
            </span>
            <!-------For Preauth Details--------------->

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Room Rent *</label>
                        <input type="number" formControlName="room_rent" class="form-control" />
                        <div *ngIf="submitted && f.room_rent.errors" class="invalid-feedback">
                            <div *ngIf="f.room_rent.errors.required">Room Rent is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Copay *</label>
                        <mat-select placeholder="Select Copay" formControlName="copay">
                            <mat-option [value]="1" >NIL</mat-option>
                            <mat-option [value]="2" >Copay not confirmed</mat-option>
                            <mat-option [value]="5" >5</mat-option>
                            <mat-option [value]="10" >10</mat-option>
                            <mat-option [value]="15" >15</mat-option>
                            <mat-option [value]="20" >20</mat-option>
                            <mat-option [value]="25" >25</mat-option>
                            <mat-option [value]="30" >30</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.copay.errors" class="invalid-feedback">
                            <div *ngIf="f.copay.errors.required">Copay is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Select Room *</label>
                        <mat-select placeholder="Select Room" formControlName="room">
                            <mat-option value="">Select Room</mat-option>
                            <mat-option [value]="1" >Single Private</mat-option>
                            <mat-option [value]="2" >Double Sharing</mat-option>
                            <!-- <mat-option [value]="4" >Three Sharing</mat-option> -->
                            <mat-option [value]="3" >General Ward</mat-option>
                            <mat-option [value]="5" >As per Insurance T&C</mat-option>
                            <mat-option [value]="6" >Day Care</mat-option>
                        </mat-select>
                        <div *ngIf="submitted && f.room.errors" class="invalid-feedback">
                            <div *ngIf="f.room.errors.required">Room is required</div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Approval Letter Number</label>
                        <input type="text" formControlName="approval_number" class="form-control" />
                    </div>

                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Status</label>
                        <mat-select placeholder="Select Room" formControlName="status">
                            <mat-option [value]="0" >Pending</mat-option>
                            <mat-option [value]="1" >Approved</mat-option>
                            <mat-option [value]="2" >Rejected</mat-option>
                            <mat-option [value]="3" >Pre Auth Pending</mat-option>
                            <!-- <mat-option [value]="4" >Pre Auth Query</mat-option>
                            <mat-option [value]="5" >Pre Auth Approved</mat-option> -->
                            <mat-option [value]="6" >Pre Approval Pending</mat-option>
                            <mat-option [value]="7" >Pre Approval Query</mat-option>
                            <mat-option [value]="8" >Pre Approval Approved</mat-option>
                            <mat-option [value]="9" >Final Approval Pending</mat-option>
                            <mat-option [value]="10" >Final Approval Query</mat-option>
                            <mat-option [value]="11" >Final Approval Approved</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Claim Number</label>
                        <input type="text" formControlName="claim_number" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Recovery Remarks</label>
                        <textarea class="form-control" formControlName="recovery_remark"></textarea>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Description</label>
                        <textarea class="form-control textareaColor" formControlName="description"></textarea>
                        <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                            <div *ngIf="f.description.errors.required">Description is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-12">
                        <label class="form-label">Queries</label>
                        <textarea class="form-control" formControlName="queries"></textarea>
                    </div>
                    <!-- <div class="col-sm-6">

                    </div> -->
                </div>
            </div>

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Disease Capping</label>
                        <mat-select placeholder="Select Disease Capping" formControlName="disease_capping">
                            <mat-option [value]="1" >Not Applicable</mat-option>
                            <mat-option [value]="2" >Applicable</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-6" *ngIf="insuranceForm.controls['disease_capping'].value==2">
                        <label class="form-label">Disease Capping Amount</label>
                        <input type="text" formControlName="disease_capping_amount" class="form-control" />
                    </div>
                </div>
            </div>
            <hr>

            <!-----For Hospital Add More Section------------>
            <div class="form-group" *ngIf="myrole=='1' || myrole=='5'">
                <div class="row">
                    <div class="col-sm-6">
                        <button type="button" (click)="addMoreHospitalAmount()" class="btn btn-primary pull-left"> Add Hospital Amount</button>
                    </div>
                </div>
            </div>
            <div formArrayName="hospitalAmtResources" style="display: contents;">
                <div class="row mt-3"  *ngFor="let quantity of hospitalAmtResources().controls; let i=index" [formGroupName]="i">
                    <div class="col-md-4">
                        <label class="form-label">Hospital</label>
                        <mat-select placeholder="Select Hospital" formControlName="hospital_id">
                            <mat-option value="">Select Hospital</mat-option>
                            <mat-option [value]="hospital.id" *ngFor="let hospital of hospitals">{{hospital.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label">Payment Mode</label>
                        <mat-select placeholder="Select Payment Mode" formControlName="payment_mode_option">
                            <mat-option value="Cashless">Cashless</mat-option>
                            <mat-option value="Reimbursement">Reimbursement</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3">
                        <label class="form-label">Amount</label>
                        <input type="number" formControlName="hospital_amount" class="form-control text-left"/>
                    </div>
                    <input type="hidden" formControlName="hospitalAmountId" >
                    <div class="col-md-2" *ngIf="myrole=='1' || myrole=='5'">
                        <label class="form-label">&nbsp;</label>
                        <button
                            class="btn btn-danger"
                            mwlConfirmationPopover
                            [popoverTitle]="popoverTitle"
                            [popoverMessage]="popoverMessage"
                            [confirmText]="confirmText"
                            [cancelText]="cancelText"
                            [placement]="placement"
                            (confirm)="removeQuantity(i, quantity.value.hospitalAmountId)"
                            (cancel)="cancelClicked = true"
                            confirmButtonType="danger"
                            cancelButtonType="outline-secondary"
                            (click)="confirmClicked = false; cancelClicked = false"
                            [appendToBody]="true">
                        Remove
                        </button>
                    </div>
                </div>
            </div>
            <!-----For Hospital Add More Section------------>
            <hr />

            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Policy Start</label>
                        <mat-form-field appearance="fill" >
                            <mat-label>Choose a date</mat-label>
                            <input matInput readonly formControlName="policy_start_on" [matDatepicker]="picker">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Policy Expire On</label>
                        <mat-form-field appearance="fill" >
                            <mat-label>Choose a date</mat-label>
                            <input matInput readonly formControlName="policy_expiry_on" [matDatepicker]="picker1">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-4 mt-4">
                        <label class="form-label">Policy Expire</label>
                        <mat-select placeholder="Select Policy Expire" formControlName="policy_expiry">
                            <mat-option [value]="1" >No</mat-option>
                            <mat-option [value]="2" >Yes</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
            <hr>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Preexisting Disease Covered</label>
                        <mat-select placeholder="Select Preexisting Disease Covered" formControlName="preexisting_disease_option">
                            <mat-option value="No" >No</mat-option>
                            <mat-option value="Yes" >Yes</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-6" *ngIf="insuranceForm.controls['preexisting_disease_option'].value=='Yes'">
                        <label class="form-label">Preexisting Disease</label>
                        <input type="text" formControlName="preexisting_disease" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Waiting Period Covered</label>
                        <mat-select placeholder="Select Waiting Period Covered" formControlName="waiting_period_option">
                            <mat-option value="No" >No</mat-option>
                            <mat-option value="Yes" >Yes</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-6" *ngIf="insuranceForm.controls['waiting_period_option'].value=='Yes'">
                        <label class="form-label">Waiting Period</label>
                        <input type="text" formControlName="waiting_period" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Portability From</label>
                        <mat-select placeholder="Select Portability From" formControlName="portability_details_from">
                            <mat-option value="">Portability From</mat-option>
                            <mat-option [value]="iscomp.id" *ngFor="let iscomp of insurance_company">{{iscomp.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Portability To (Current)</label>
                        <mat-select placeholder="Select Portability To" formControlName="portability_details_current">
                            <mat-option value="">Portability To</mat-option>
                            <mat-option [value]="iscomp.id" *ngFor="let iscomp of insurance_company">{{iscomp.name}}</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Day Care</label>
                        <mat-select placeholder="Select Day Care" formControlName="day_care_option">
                            <mat-option value="No" >No</mat-option>
                            <mat-option value="Yes" >Yes</mat-option>
                        </mat-select>
                    </div>
                </div>
            </div>


            <div class="card-footer" *ngIf="myrole=='1' || myrole=='5'">
                <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Update</button>
            </div>
            </form>
        </div>
        <div class="col-sm-4">
            <h2>Insurance Documents</h2>
            <div class="form-group">
                <label>Select Document Type</label>
                <mat-select [(ngModel)]="doc_type" placeholder="Select Document Type">
                    <mat-option value="">Select Document Type</mat-option>
                     <mat-option [value]="1">Aadhar / Other Document</mat-option>
                    <mat-option [value]="2">Insurance Card</mat-option>
                    <mat-option [value]="3">Pre Auth</mat-option>
                    <mat-option [value]="4">Pre Approval</mat-option>
                    <mat-option [value]="5">Final Approval</mat-option>
                    <mat-option [value]="6">Settlement Letter</mat-option>
                    <mat-option [value]="7">Query Letter</mat-option>
                </mat-select>
            </div>
            <div class="form-group">
                <label>Upload Documents</label>
                <input type="file" (change)="selectFile($event)" class="form-control" />
                <span *ngIf="uploading"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
            </div>

            <div class="list-group list-group-flush list-group-hoverable">
                <div class="list-group-item" *ngFor="let upload of allUploads">
                    <div class="row align-items-center">
                        <div class="col-md-10">
                            <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>
                        </div>
                        <div class="col-md-2">
                            <a *ngIf="myrole=='1' || myrole=='2' || myrole=='3' || myrole=='5'" class="delete-file text-danger fa-pull-right" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                            [cancelText]="cancelText" [placement]="placement" (confirm)="removeFileInsurance(upload.id)" (cancel)="cancelClicked = true"
                            confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                            [appendToBody]="true"><i class="fa fa-trash"></i></a>
                        </div>
                        <div class="col text-truncate">
                            <span class="badge badge-danger" *ngIf='upload.upload_type==1'>Aadhar/ Other Docs</span>
                            <span class="badge badge-info" *ngIf='upload.upload_type==2'>Insurance Card</span>
                            <span class="badge badge-info" *ngIf='upload.upload_type==3'>Pre Auth</span>
                            <span class="badge badge-info" *ngIf='upload.upload_type==4'>Pre Approval</span>
                            <span class="badge badge-info" *ngIf='upload.upload_type==5'>Final Approval</span>
                            <span class="badge badge-info" *ngIf='upload.upload_type==6'>Settlement Letter</span>
                            <span class="badge badge-info" *ngIf='upload.upload_type==7'>Query Letter</span>
                            <span class="float-right badge badge-default">{{upload.created_at*1000|date:'dd MMM, yyyy hh:mm aa'}}</span>
                            <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="allPreauthUploads.length > 0">
                <div class="form-group mt-5"><label class="form-label">Pre Auth Files</label></div>
                <div class="list-group list-group-flush list-group-hoverable">
                    <div class="list-group-item" *ngFor="let upload of allPreauthUploads">
                        <div class="row align-items-center">
                            <div class="col-md-10">
                            <a href="{{s3url}}{{upload.filepath}}" target="_blank" class="text-body d-block">View File</a>
                            </div>
                            <div class="col-md-2">
                                <a *ngIf="myrole=='1' || myrole=='2' || myrole=='3' || myrole=='5'" class="delete-file text-danger fa-pull-right" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                                [cancelText]="cancelText" [placement]="placement" (confirm)="removeFileInsurance(upload.id)" (cancel)="cancelClicked = true"
                                confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                                [appendToBody]="true"><i class="fa fa-trash"></i></a>
                            </div>
                            <div class="col text-truncate">
                                <span class="badge badge-danger" *ngIf='upload.upload_type==1'>Aadhar/ Other Docs</span>
                                <span class="badge badge-info" *ngIf='upload.upload_type==8'>Pan</span>
                                <span class="badge badge-secondary" *ngIf='upload.upload_type==9'>Doctor Prescription</span>
                                <span class="badge badge-primary" *ngIf='upload.upload_type==10'>Report</span>
                                <span class="float-right badge badge-default">{{upload.created_at*1000|date:'dd MMM, yyyy hh:mm aa'}}</span>
                                <small class="d-block text-muted text-truncate mt-n1">{{upload.filepath}}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
